export default "__VITE_ASSET__z8IqaDpT53LmDJcH$tHz3g__";